import { nanoid } from '@reduxjs/toolkit'
import { forEach } from 'lodash'
import ActionTypes from '@constants/action_types.js'
import ToastTypes from '@constants/toast_types.js'

export function toastInfo(message) {
  return toast(message, ToastTypes.INFO)
}

export function toastSuccess(message) {
  return toast(message, ToastTypes.SUCCESS)
}

export function toastError(message) {
  return toast(message, ToastTypes.ERROR)
}

export function toastWarning(message) {
  return toast(message, ToastTypes.WARNING)
}

export function toastFlash(flash) {
  return (dispatch, getState) => {
    if (flash && Array.isArray(flash)) {
      forEach(flash, item => {
        const [type, message] = item
        switch (type) {
          case 'success':
            dispatch(toastSuccess(message))
            break

          case 'notice':
            dispatch(toastInfo(message))
            break

          case 'alert':
            dispatch(toastError(message))
            break

          default:
            dispatch(toastInfo(message))
        }
      })
    }
  }
}

export function removeToast(uid) {
  return {
    type: ActionTypes.REMOVE_TOAST,
    payload: uid,
  }
}

export function toast(message, level = ToastTypes.INFO) {
  return {
    type: ActionTypes.ADD_TOAST,
    payload: {
      message,
      level: getLevel(level),
      uid: nanoid(),
    },
  }
}

function getLevel(toastLevel) {
  switch (toastLevel) {
    case ToastTypes.SUCCESS:
      return 'success'

    case ToastTypes.ERROR:
      return 'error'

    case ToastTypes.WARNING:
      return 'warning'

    case ToastTypes.INFO:
      return 'info'

    default:
      return 'info'
  }
}
